<payee-form-field width="wide">
  <div
    payee-label
    class="flex vcenter"
  >
    <span>
      {{ "CLIENT_NOTIFICATION_SETTINGS.FINANCE_EMAIL.LABEL" | translate }}
    </span>
    @if (loading()) {
      <mat-progress-spinner
        diameter="24"
        mode="indeterminate"
      ></mat-progress-spinner>
    }
  </div>
  <input
    payee-input
    [formControl]="financeEmailControl"
  />
  @if (financeEmailControl.dirty && financeEmailControl.invalid) {
    <ng-container payee-error>
      <mat-error>{{ "ERROR_MESSAGES.INVALID_FORMAT" | translate }}</mat-error>
    </ng-container>
  }
</payee-form-field>
